module.exports = __webpack_public_path__ + "static/media/swirl.fa92afa7.png";